import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuditTrialDetails } from '../../../../shared/models/audits/audit-trial-details';
import { FilterMenu } from '../../../../shared/models/filter-menu';
import { PanelList } from '../../../../shared/models/panel-list';
import { SortMenu } from '../../../../shared/models/sort-menu';

@Component({
  selector: 'app-user-profile-audit-summary',
  templateUrl: './user-profile-audit-summary.component.html',
  styleUrls: ['./user-profile-audit-summary.component.scss']
})
export class UserProfileAuditSummaryComponent implements OnInit, OnChanges {
  @Input() summaryData: AuditTrialDetails[] = [];
  @Output() onItemSelected = new EventEmitter<AuditTrialDetails>();

  isSummaryLoaded = false;
  userProfileAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight: true
  };

  ngOnInit(): void {
    this.bindUserProfileAuditSummary();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['summaryData']) {
      this.bindUserProfileAuditSummary();
    }
  }

  bindUserProfileAuditSummary(): void {
    this.userProfileAuditSummaryInput.lists = this.summaryData;
    this.userProfileAuditSummaryInput.filters = this.getFiltersForUserProfileAuditList();
    this.userProfileAuditSummaryInput.sort = this.getSortFieldsForUserProfileAuditList();
    this.userProfileAuditSummaryInput.clearSelection = true;
    this.isSummaryLoaded = true;
    this.userProfileAuditSummaryInput = { ...this.userProfileAuditSummaryInput };
  }

  private getFiltersForUserProfileAuditList(): FilterMenu[] {
    return [
      {
        filterDisplayName: 'User',
        filterFieldName: 'user'
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action'
      }
    ];
  }

  private getSortFieldsForUserProfileAuditList(): SortMenu[] {
    return [
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user'
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action'
      },
      {
        sortFieldDisplayName: 'Timestamp',
        sortFieldName: 'timestamp'
      }
    ];
  }

  showAuditAttributeDetails(data: AuditTrialDetails): void {
    this.onItemSelected.emit(data);
  }

}
